"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BureauLogo = exports.FicoLogo = exports.TxuLogo = exports.DnbLogo = exports.XpnLogo = exports.EqxLogo = exports.StyledHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const CLIENT_CDN_BASE_URL = (_a = global.process.env.CLIENT_CDN_BASE_URL) !== null && _a !== void 0 ? _a : 'https://dxkdvuv3hanyu.cloudfront.net';
const Logo = styled_components_1.default.img.withConfig({ displayName: "reports-Logo", componentId: "reports-1haui8r" }) `
  display: block;
  margin-bottom: 8px;
  width: 130px;
`;
const ExperianLogo = (0, styled_components_1.default)(Logo).withConfig({ displayName: "reports-ExperianLogo", componentId: "reports-28luqd" }) `
  max-width: 100px;
`;
exports.StyledHeader = styled_components_1.default.div.withConfig({ displayName: "reports-StyledHeader", componentId: "reports-4h07mi" }) `
  display: flex;
  border-bottom: solid 1px ${base_react_components_1.theme.neutral300};
  padding-bottom: 16px;

  & > ${base_react_components_1.Copy} {
    color: ${base_react_components_1.theme.neutral400};
    padding-left: 16px;
    align-self: center;
  }
`;
exports.EqxLogo = (0, styled_components_1.default)((_a) => {
    var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
    return (react_1.default.createElement(exports.StyledHeader, Object.assign({ className: className }, rest),
        react_1.default.createElement(ExperianLogo, { src: `${CLIENT_CDN_BASE_URL}/design-assets/logos/equifax-logo.svg`, alt: "Equifax" }),
        react_1.default.createElement(base_react_components_1.Copy, { size: "md" }, label !== null && label !== void 0 ? label : 'Business Delinquency Score®')));
}).withConfig({ displayName: "reports-EqxLogo", componentId: "reports-8aiopb" }) ``;
exports.XpnLogo = (0, styled_components_1.default)((_a) => {
    var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
    return (react_1.default.createElement(exports.StyledHeader, Object.assign({ className: className }, rest),
        react_1.default.createElement(ExperianLogo, { src: `${CLIENT_CDN_BASE_URL}/design-assets/logos/experian.svg`, alt: "Experian" }),
        react_1.default.createElement(base_react_components_1.Copy, { size: "md" }, label !== null && label !== void 0 ? label : 'Intelliscore Plus℠ V2')));
}).withConfig({ displayName: "reports-XpnLogo", componentId: "reports-1992qzd" }) ``;
exports.DnbLogo = (0, styled_components_1.default)((_a) => {
    var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
    return (react_1.default.createElement(exports.StyledHeader, Object.assign({ className: className }, rest),
        react_1.default.createElement(Logo, { src: `${CLIENT_CDN_BASE_URL}/design-assets/logos/dandb-logo.svg`, alt: "Dun & Bradstreet" }),
        react_1.default.createElement(base_react_components_1.Copy, { size: "md" }, label !== null && label !== void 0 ? label : 'PAYDEX®')));
}).withConfig({ displayName: "reports-DnbLogo", componentId: "reports-6xudfu" }) ``;
exports.TxuLogo = (0, styled_components_1.default)((_a) => {
    var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
    return (react_1.default.createElement(exports.StyledHeader, Object.assign({ className: className }, rest),
        react_1.default.createElement(Logo, { src: `${CLIENT_CDN_BASE_URL}/images/transunion-logo.png`, alt: "TransUnion" }),
        react_1.default.createElement(base_react_components_1.Copy, { size: "md" }, label !== null && label !== void 0 ? label : 'VantageScore® 3.0')));
}).withConfig({ displayName: "reports-TxuLogo", componentId: "reports-h32ws" }) ``;
exports.FicoLogo = (0, styled_components_1.default)((_a) => {
    var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
    return (react_1.default.createElement(exports.StyledHeader, Object.assign({ className: className }, rest),
        react_1.default.createElement(Logo, { src: `${CLIENT_CDN_BASE_URL}/design-assets/logos/sbss-by-fico_99x50.png`, alt: "SBSS by FICO" }),
        react_1.default.createElement(base_react_components_1.Copy, { size: "md" }, label !== null && label !== void 0 ? label : 'Small Business Scoring Service℠')));
}).withConfig({ displayName: "reports-FicoLogo", componentId: "reports-8r0ilt" }) ``;
/**
 * Returns a bureau logo and credit score label frequently used for titles
 *
 * @param props
 * @returns
 */
const BureauLogo = (_a) => {
    var { bureau } = _a, props = __rest(_a, ["bureau"]);
    if (bureau === 'xpn') {
        return react_1.default.createElement(exports.XpnLogo, Object.assign({}, props));
    }
    else if (bureau === 'dnb') {
        return react_1.default.createElement(exports.DnbLogo, Object.assign({}, props));
    }
    else if (bureau === 'eqx') {
        return react_1.default.createElement(exports.EqxLogo, Object.assign({}, props));
    }
    else if (bureau === 'txu') {
        return react_1.default.createElement(exports.TxuLogo, Object.assign({}, props));
    }
    else if (bureau === 'fico') {
        return react_1.default.createElement(exports.FicoLogo, Object.assign({}, props));
    }
    return null;
};
exports.BureauLogo = BureauLogo;
exports.default = exports.BureauLogo;
//# sourceMappingURL=index.js.map